import { Card, CardContent, CardHeader, Grid, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { useLocation, useNavigate } from 'react-router-dom'
import TabelPerencanaan from 'examples/Tables/TabelPerencanaan'
import userStore from 'store/userStore'
import { CustomDescrypt } from 'global/func'
import { decodeToken } from 'react-jwt'
import { useEffect, useState } from 'react'
import { ArrowBack, AttachMoney } from '@mui/icons-material'
import Swal from 'sweetalert2'
import { postDelete } from 'global/postFunc'
import { postDataWithResponse } from 'global/postFunc'
import MiniStatisticsCard from 'examples/Cards/StatisticsCards/MiniStatisticsCard'
import TambahKegiatan from './FormPerencanaan/TambahKegiatan'
import TambahSubKegiatan from './FormPerencanaan/TambahSubKegiatan'
import EditProgram from './FormPerencanaan/EditProgram'

const DetailKegiatan = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [totalAnggaran, setTotalAnggaran] = useState(0)
    const [updating, setUpdating] = useState(false)
    const [loading, setLoading] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const [parentData, setParentData] = useState({})
    const [openAddChild, setOpenAddChild] = useState(false);
    const handleOpenAddChild = () => setOpenAddChild(true);
    const handleCloseAddChild = () => setOpenAddChild(false);

    const navigate = useNavigate()
    const location = useLocation()
    const locationData = location.state

    const [openEdit, setOpenEdit] = useState(false)
    const [editData, setEditData] = useState({})
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    const [opd, setOpd] = useState({})
    
    console.log(locationData);

    const reqPerencanaan = (params) => {
        if (params) {
            setLoading(true)
            addReq()
            postDataWithResponse(
                `/admin-opd/get-tr-sub-kegiatan-by-kegiatan`,
                {
                    id: locationData.program.id,
                    ta: locationData.program.ta,
                    kd_pd: locationData.program.kd_pd,
                    kode: locationData.program.kode,
                    ket: locationData.program.ket
                },
                decryptedUser,
                (res) => {
                    setData(res.subKegiatans)
                    setTotalAnggaran(parseInt(res.total_anggaran))
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
            );
        }
    }

    useEffect(() => {
        console.log(decodedUser);
        setOpd({
            kd_pd: decodedUser.kd_pd,
            nm_pd: decodedUser.nm_pd
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(opd);
        reqPerencanaan(opd.kd_pd)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opd, updating, deleting])

    const deleteData = (kode, ket) => {
        Swal.fire({
            title: 'Hapus Data?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/admin-opd/tr-perencanaan/delete',
                    {
                        _method: 'DELETE',
                        kode: kode,
                        ket: ket
                    },
                    decryptedUser,
                    setLoading,
                    () => { setDeleting(!deleting) }
                )
            }
        })
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack /></IconButton>
                        }
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {locationData.program.ta}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {opd.kd_pd} {opd.nama_pd}</TableCell>
                                </TableRow>
                                <TableRow key={2} >
                                    <TableCell sx={{ fontSize: 'small' }}>Program</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {locationData.program.kode} {locationData.program.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={8} >
                                    <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        : {
                                            locationData.program.anggaran?.toLocaleString?.('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            bgColor='white'
                            title={{
                                text: "Total Angaran Program"
                            }}
                            count={
                                locationData.program.anggaran?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "info", component: <AttachMoney /> }}
                        // percentage={{ color: "success", count: "+55%", text: "since yesterday" }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <MiniStatisticsCard
                            title={{
                                text: "Anggaran Kegiatan Terinput"
                            }}
                            count={
                                totalAnggaran?.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                            icon={{ color: "error", component: <AttachMoney /> }}
                            percentage={{ color: (totalAnggaran / locationData.program.anggaran) === 1 ? 'success' : 'error', text: ((totalAnggaran / locationData.program.anggaran) * 100).toFixed(2) + '%' }}
                        />
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Perencanaan</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <TabelPerencanaan
                                data={data}
                                loading={loading}
                                handleOpenAddChild={handleOpenAddChild}
                                setParentData={setParentData}
                                setEditData={setEditData}
                                handleOpenEdit={handleOpenEdit}
                                deleteData={deleteData}
                                opd={opd}
                                baseUrl="/a-pd/perencanaan"
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>

            <TambahKegiatan
                decryptedUser={decryptedUser}
                tahunAnggaran={tahunAnggaran}
                open={openAddChild && parentData.ket === 'PROGRAM'}
                handleCloseDialog={handleCloseAddChild}
                parentData={parentData}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />

            <TambahSubKegiatan
                decryptedUser={decryptedUser}
                tahunAnggaran={tahunAnggaran}
                open={openAddChild && parentData.ket === 'KEGIATAN'}
                handleCloseDialog={handleCloseAddChild}
                parentData={parentData}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />

            <EditProgram
                decryptedUser={decryptedUser}
                editData={editData}
                open={openEdit}
                handleCloseDialog={handleCloseEdit}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />
        </ArgonBox>
    )
}

export default DetailKegiatan